import { Box, styled } from '@mui/material';

/**
 * The applied filters as one row of chips under the controls, wrapping onto a next line when they run out
 * of room. Only there when something is applied, so it costs no height otherwise.
 */
export const AppliedFiltersRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: theme.spacing(1),
  minWidth: 0,
  paddingBottom: theme.spacing(3)
}));
